// extracted by mini-css-extract-plugin
export default {"community":"Community_community__BcNbI","wrapper":"Community_wrapper__ml9ei","titleWrap":"Community_titleWrap__onZs4","formWrap":"Community_formWrap__5qZpO"};